import WorkFlowPage from 'pages/workflow/page'

export const workFlowRoutes = [{ path: '/workflow', element: <WorkFlowPage /> }]
